import { Paths } from "MainRouter";
import React from "react";
import { Link } from "react-router-dom";

import "./Products.styles.scss";

const ProductsSection = () => {
	return (
		<div className="products-outer">
			<div className="products-wrapper">
				<div className="products-heading">
					<p className="products-eyebrow">Our Apps</p>
					<h3 className="products-title">Products by Eurycele</h3>
					<p className="products-sub">
						Carefully crafted tools designed to make everyday tasks smarter and simpler.
					</p>
				</div>

				<div className="products-grid">
					<div className="product-card">
						<div aria-hidden="true" className="product-card-accent" />

						<div className="product-icon-wrap">
							<img alt="WireDrop" src="/assets/images/wiredrop-logo.png" />
						</div>

						<div className="product-body">
							<h4 className="product-name">WireDrop</h4>
							<p className="product-tagline">Fast, secure, local network messaging and file sharing.</p>
							<p className="product-desc">
								WireDrop is a LAN-based messaging and file-sharing app that helps users share messages, files,
								and folders across devices connected to the same local network.
							</p>

							<div className="product-meta">
								<span className="product-badge">
									<i aria-hidden="true" className="fa-brands fa-windows" />
									Windows
								</span>
								<span className="product-badge">
									<i aria-hidden="true" className="fa-brands fa-android" />
									Android
								</span>
								<span className="product-badge">
									<i aria-hidden="true" className="fa-brands fa-ubuntu" />
									Ubuntu
								</span>
							</div>

							<Link className="product-cta" to={Paths.wiredropDownload}>
								<i aria-hidden="true" className="fa-solid fa-arrow-down" />
								Download WireDrop
							</Link>
							<a
								className="product-store-link"
								href="https://apps.microsoft.com/store/detail/9NN4S868G1LV?cid=DevShareMWAPCS"
								rel="noreferrer"
								target="_blank">
								<i aria-hidden="true" className="fa-brands fa-microsoft" />
								Get from Microsoft Store
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProductsSection;
